import type { TenantBranding } from '@senviro/core-api-client';

/**
 * Senviro platform defaults — the fallback when a partner hasn't completed
 * the W5-F5 onboarding wizard yet (or when the proxy returns 404). The
 * shape mirrors `TenantBrandingRead` exactly so swapping in real data
 * never changes the consumer surface.
 *
 * Color tokens land at `:root` via `<TenantBrandingProvider>` — keep them
 * in sync with the design tokens in `apps/web/src/styles/tokens.css`.
 */
export const defaultBranding: TenantBranding = {
  id: 'senviro-platform-defaults',
  organization_id: 'senviro-platform',
  product_name: 'Senviro',
  product_short_name: 'Senviro',
  logo_url: null,
  favicon_url: null,
  login_background_url: null,
  login_logo_url: null,
  color_primary: '#2563EB',
  color_accent: '#F59E0B',
  font_heading: '"Geist Variable", Geist, system-ui, sans-serif',
  font_body: '"Geist Variable", Geist, system-ui, sans-serif',
  email_from_address: 'noreply@senviro.dev',
  email_from_name: 'Senviro',
  support_email: 'support@senviro.dev',
  custom_domain: null,
  active: true,
  content_source: 'human',
  ai_confidence: null,
  ai_reasoning: null,
  ai_model_code: null,
  import_source: null,
  created_by_user_id: null,
  source_app: 'senviro',
  created_at: '2026-05-04T00:00:00Z',
  updated_at: '2026-05-04T00:00:00Z',
  deleted_at: null,
};
